export const CALENDAR_ENTRY_STATUS_CREATE = 'CALENDAR_ENTRY_STATUS_CREATE'
export const CALENDAR_ENTRY_STATUS_CREATE_SUBMIT = 'CALENDAR_ENTRY_STATUS_CREATE_SUBMIT'
export const CALENDAR_ENTRY_STATUS_CREATE_FAILURE = 'CALENDAR_ENTRY_STATUS_CREATE_FAILURE'

export const CALENDAR_ENTRY_STATUS_UPDATE = 'CALENDAR_ENTRY_STATUS_UPDATE'
export const CALENDAR_ENTRY_STATUS_UPDATE_SUBMIT = 'CALENDAR_ENTRY_STATUS_UPDATE_SUBMIT'
export const CALENDAR_ENTRY_STATUS_UPDATE_FAILURE = 'CALENDAR_ENTRY_STATUS_UPDATE_FAILURE'

export const CALENDAR_ENTRY_STATUS_DELETE = 'CALENDAR_ENTRY_STATUS_DELETE'
export const CALENDAR_ENTRY_STATUS_DELETE_SUBMIT = 'CALENDAR_ENTRY_STATUS_DELETE_SUBMIT'
export const CALENDAR_ENTRY_STATUS_DELETE_FAILURE = 'CALENDAR_ENTRY_STATUS_DELETE_FAILURE'
